import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {KnowledgeArticleForm} from 'src/pages/Modules/KnowledgeBase/shared/KnowledgeArticleForm';
import {KnowledgeBaseDocumentTitle} from 'src/pages/Modules/KnowledgeBase/shared/knowledgeArticleHelpers';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {parseNumericParam} from 'src/shared/utils/parseNumericParam';

export const KnowledgeArticleEditPage = () => {
  useSetDocumentTitle(KnowledgeBaseDocumentTitle);
  const {id} = useParams();

  const validId = parseNumericParam(id);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.KnowledgeBase}>
      <KnowledgeArticleForm mode="edit" id={validId} />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.KnowledgeBaseEdit(':id'),
  element: <KnowledgeArticleEditPage />,
  module: ModuleEnum.KnowledgeBase,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
